(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-main-facets"] && !Shopify.designMode) return;
  try {
    // Reset Filters

    function resetFilters(event) {
        event.preventDefault();
        const url = new URL(window.location.href);
        const paramsToDelete = [];
        url.searchParams.forEach((value, key) => {
            if (key.startsWith('filter.')) {
            paramsToDelete.push(key);
            }
        });
        paramsToDelete.forEach(param => url.searchParams.delete(param));
        window.location.href = url.pathname + url.search;
    }
    document.querySelector('.reset_filters_button')?.addEventListener('click', resetFilters);

    // Open Filters
    const drawer = document.querySelector('.facets-drawer');
    const buttons = document.querySelectorAll('.collection_facets_button');
    const drawerCloseButton = document.querySelector('.close_filter_drawer_button');

    document.addEventListener('click', function (e) {
        if (!drawer || buttons.length === 0) return;

        // Check if any button was clicked
        const clickedButton = [...buttons].find(btn => btn.contains(e.target));
        if (clickedButton) {
            e.preventDefault();

            const button_name = clickedButton.getAttribute('data-name');
            const form = document.querySelector('.collections_filter_form');
            const sort_by = document.querySelector('.sort-facets-container');
            const drawer_title = document.querySelector('.filter-drawer-title');

            if (button_name === 'sort') {
                form.style.display = 'none';
                sort_by.style.display = 'block';
                drawer_title.textContent = 'Sort By';

            }else {
                form.style.display = 'block';
                sort_by.style.display = 'none';
                drawer_title.textContent = 'Filters';

            }

            drawer.classList.toggle('show');

            // Toggle active only on the clicked button
            clickedButton.classList.toggle('active');
            return;
        }

        // Click outside drawer
        if (!drawer.contains(e.target)) {
            drawer.classList.remove('show');

            // Remove active from all buttons
            buttons.forEach(btn => btn.classList.remove('active'));
        }
    });

    // Drawer close function 
    if(drawerCloseButton) {
        drawerCloseButton.addEventListener('click', function (e) {
            e.preventDefault();
            drawer.classList.remove('show');
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        const sortInputs = document.querySelectorAll('input[name="sort_by"]');
        if (!sortInputs.length) return;

        const params = new URLSearchParams(window.location.search);
        const currentSort = params.get('sort_by');

        // Auto select active sort
        if (currentSort) {
            const activeInput = document.querySelector(`input[name="sort_by"][value="${currentSort}"]`);
            if (activeInput) {
            activeInput.checked = true;
            }
        }

        // Sort functionality
        sortInputs.forEach(function (input) {
            input.addEventListener('change', function () {
                sortInputs.forEach(cb => cb.checked = false);
                this.checked = true;
                const sortValue = this.value;
                const url = new URL(window.location.href);
                url.searchParams.set('sort_by', sortValue);
                window.location.href = url.toString();
            });
        });
    });

    // Price filter

    const minSlider = document.getElementById("range-min");
    const maxSlider = document.getElementById("range-max");

    const track = document.querySelector(".slider-track");
    const minBullet = document.getElementById("rs-bullet-1");
    const maxBullet = document.getElementById("rs-bullet-2");

    const applyBtn = document.querySelector(".apply_filters_button");

    const priceGte = document.querySelector('input[name="filter.v.price.gte"]');
    const priceLte = document.querySelector('input[name="filter.v.price.lte"]');

    const form = (applyBtn ? applyBtn.closest("form") : null);

    const maxRange = parseInt(minSlider.max, 10) || 1;

    function formatMoney(val) {
        return "₹" + (val / 100).toLocaleString("en-IN");
    }

    // ✅ On page load, sync slider thumbs to current applied price filter.
    function syncFromCurrentPrice() {
        const url = new URL(window.location.href);
        const gteParam = url.searchParams.get("filter.v.price.gte");
        const lteParam = url.searchParams.get("filter.v.price.lte");

        // Prefer the actual form hidden inputs if they exist (some themes pre-fill them),
        // otherwise fall back to URL params.
        const gteRaw = priceGte?.value || gteParam;
        const lteRaw = priceLte?.value || lteParam;

        const gte = parseInt(gteRaw, 10);
        const lte = parseInt(lteRaw, 10);

        if (Number.isNaN(gte) && Number.isNaN(lte)) return;

        // Your slider scale is "paise-like": rupees * 100.
        const sliderMin = Number.isNaN(gte) ? parseInt(minSlider.value, 10) : gte * 100;
        const sliderMax = Number.isNaN(lte) ? parseInt(maxSlider.value, 10) : lte * 100;

        let lo = Math.max(parseInt(minSlider.min, 10), sliderMin);
        let hi = Math.min(parseInt(minSlider.max, 10), sliderMax);

        if (lo > hi) [lo, hi] = [hi, lo];

        minSlider.value = lo;
        maxSlider.value = hi;
    }

    function updateSlider() {
        let minVal = parseInt(minSlider.value, 10);
        let maxVal = parseInt(maxSlider.value, 10);

        if (minVal > maxVal) {
        minSlider.value = maxVal;
        minVal = maxVal;
        }

        const minPercent = (minVal / maxRange) * 100;
        const maxPercent = (maxVal / maxRange) * 100;

        track.style.left = minPercent + "%";
        track.style.width = (maxPercent - minPercent) + "%";

        minBullet.innerHTML = formatMoney(minVal);
        maxBullet.innerHTML = formatMoney(maxVal);

        minBullet.style.left = minPercent + "%";
        maxBullet.style.left = maxPercent + "%";
    }

    minSlider.addEventListener("input", updateSlider);
    maxSlider.addEventListener("input", updateSlider);

    // Custom function: runs price logic + submits the same form so
    // swatch/availability filters (checkboxes) are included too.
    function applyAllFilters(event) {
        let minVal = parseInt(minSlider.value, 10);
        let maxVal = parseInt(maxSlider.value, 10);

        if (minVal > maxVal) {
        [minVal, maxVal] = [maxVal, minVal];
        minSlider.value = minVal;
        maxSlider.value = maxVal;
        }

        // keep your existing price scaling
        const minRupees = Math.round(minVal / 100);
        const maxRupees = Math.round(maxVal / 100);

        // Preferred: set Shopify hidden price inputs, then let the normal
        // form submission proceed so other filters stay included.
        if (form && priceGte && priceLte) {
        priceGte.value = minRupees;
        priceLte.value = maxRupees;
        return; // do NOT preventDefault; default submit keeps other filters
        }

        // Fallback: build URL from current form selections (includes other filters)
        event.preventDefault();
        if (!form) return;

        const params = new URLSearchParams(new FormData(form));
        params.set("filter.v.price.gte", minRupees);
        params.set("filter.v.price.lte", maxRupees);

        // Preserve sort_by if it's already selected (it lives outside the <form>)
        const sortInput = document.querySelector('input[name="sort_by"]:checked');
        const sortVal = sortInput?.value;
        if (sortVal) params.set("sort_by", sortVal);

        const url = new URL(window.location.href);
        window.location.href = url.pathname + "?" + params.toString();
    }

    applyBtn?.addEventListener("click", applyAllFilters);

    syncFromCurrentPrice();
    updateSlider();
  } catch(e) { console.error(e); }
})();

})();
